import Currencies from 'functions/currency/getCurrencySymbol'
import React, { useEffect, useState } from 'react'
import { StopFooterDiv } from './StopStyled'

interface StopFooter {
  toggleIsAutoOn: any
  bet: any
  // setStopAnimation: any
  betCount: any
  betTotal: any
  fadeOut: any
  toFix: any
  currency: any
}

export const StopFooter = ({
  toggleIsAutoOn,
  bet,
  // setStopAnimation,
  betCount,
  betTotal,
  fadeOut,
  toFix,
  currency
}: StopFooter) => {
  const [dashWidth, setDashwidth] = useState<any>(null)
  const [dashWidthR, setDashwidthR] = useState(0)
  const [isInfinite, setIsInfinite] = useState(false)
  const [test, setTest] = useState(0)
  const [duration] = useState('1200ms')
  useEffect(() => {
    if (parseInt(betTotal) > 0) {
      setIsInfinite(false)
      if (betCount - 1 < parseInt(betTotal) && dashWidth >= 0) {
        setDashwidth(
          634.7 -
            634.7 / parseInt(betTotal) -
            (634.7 / parseInt(betTotal)) * (betCount - 1) >=
            0
            ? 634.7 -
                634.7 / parseInt(betTotal) -
                (634.7 / parseInt(betTotal)) * (betCount - 1)
            : 0
        )
        setDashwidthR(
          634.7 / parseInt(betTotal) +
            (634.7 / parseInt(betTotal)) * (betCount - 1)
        )
        setTest(634.7 / parseInt(betTotal))
      }
    } else {
      setIsInfinite(true)
    }
  }, [dashWidth, betCount, betTotal])

  return (
    <StopFooterDiv
      myWidth={dashWidth}
      myWidthReverse={dashWidthR}
      duration={duration}
      fadeOut={fadeOut}
      betTotal={betTotal}
      test={test}
      onClick={() => {
        // setStopAnimation()
        setTimeout(() => {
          toggleIsAutoOn(false)
        }, 200)
      }}
    >
      <svg style={{ display: 'none' }}>
        <defs>
          <symbol id='loopingPath' viewBox='-2 -2 289 60'>
            <path
              d='M27.143,0H257.857C272.848,0,285,12.536,285,28s-12.152,28-27.143,28H27.143C12.152,56,0,43.464,0,28S12.152,0,27.143,0Z'
              fill='none'
            />
          </symbol>

          <symbol id='back' viewBox='-2 -2 289 60'>
            <path
              d='M27.143,0H257.857C272.848,0,285,12.536,285,28s-12.152,28-27.143,28H27.143C12.152,56,0,43.464,0,28S12.152,0,27.143,0Z'
              stroke='none'
              fill='#ffffff'
            />
          </symbol>
        </defs>
      </svg>
      <svg className='loading-spinner'>
        <use id='background' xlinkHref='#loopingPath' />
        {isInfinite ? (
          <use id='infinite' xlinkHref='#loopingPath' />
        ) : (
          <use id='nonInfinite' xlinkHref='#loopingPath' />
        )}
        <use id='text' xlinkHref='#text' />
        <use id='back' xlinkHref='#back' />
        {/* <text textAnchor="middle" y="46" fontSize="10" fill="#ffb000">
              {(+bet).toFixed(toFix)} {currencies[currency]}
            </text> */}
        <g id='text'>
          <text textAnchor='middle' y='30' fontSize='20' fill='#ffb000'>
            STOP
          </text>
        </g>
      </svg>
      <p id='bet'>
      {Currencies[currency]}{(+bet).toFixed(toFix)} 
      </p>
    </StopFooterDiv>
  )
}

// export const Curr = styled.div`
//   path {
//     fill: red;
//   }
// `
